// El corte semanal de una venta — lógica PURA, sin React. Va de lunes a domingo, como lo cierra el
// motor, y se nombra por su lunes: el mismo `periodId` que usan Comisiones y Mis comisiones.
import { mxDay } from '@/lib/dateHelpers';
import { weekStart } from '@/domains/retail/admin/comisiones/lib/payoutPeriods';

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * El lunes del corte en que cae una venta, por su día en el piso de venta (`mxDay`): una venta de
 * las 22:30 de un domingo en CDMX es lunes en UTC. `null` si la fecha no es utilizable.
 */
export function weeklyCutFor(soldAtIso: string): string | null {
    const day = mxDay(soldAtIso);
    // El listado se castea sin validar: una fecha ilegible degrada a `null` en vez de lanzar.
    return ISO_DAY.test(day) ? weekStart(day) : null;
}
